<template>
  <router-view/>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue';
import initializeScript from '@/assets/app.js';

export default defineComponent({
  setup () {
    onMounted(async() => {
      initializeScript.script();
    });
  },
});
</script>

<style lang="scss">
@import '~@/assets/styles';
</style>
